import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const infoItems = [
  { label: 'Dénomination', value: 'HASPICA' },
  { label: 'Dirigeant', value: 'Patrik Haspica' },
  { label: 'Statut juridique', value: 'Entrepreneur individuel' },
  { label: 'SIRET', value: '102 262 441 00011' },
  { label: 'Code NAF', value: '74.10Z — Activités spécialisées de design' },
  { label: 'Adresse', value: '12 Rue Judaïque, 33000 Bordeaux, France' },
  { label: 'Téléphone', value: '+33 7 53 49 52 45', href: 'tel:+33753495245' },
  { label: 'Email', value: 'patr1khaspica@inbox.eu', href: 'mailto:patr1khaspica@inbox.eu', rel: 'nofollow' },
];

export default function InformationsPage() {
  useEffect(() => {
    document.title = 'Informations entreprise — HASPICA Studio de Design Bordeaux';
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Navbar />

      <main className="pt-36 pb-24 px-6">
        <div className="max-w-3xl mx-auto">
          <p className="text-xs font-semibold text-neutral-400 uppercase tracking-widest mb-5">Légal</p>
          <h1 className="font-heading text-4xl md:text-5xl text-neutral-900 font-light mb-12">
            Informations entreprise
          </h1>

          <div className="space-y-0">
            {infoItems.map((item) => (
              <div
                key={item.label}
                className="flex flex-col sm:flex-row sm:items-baseline gap-1 sm:gap-8 py-5 border-b border-neutral-100"
              >
                <span className="text-xs font-semibold text-neutral-400 uppercase tracking-wider w-40 shrink-0">
                  {item.label}
                </span>
                {item.href ? (
                  <a
                    href={item.href}
                    rel={item.rel}
                    className="text-sm text-neutral-900 hover:text-neutral-600 transition-colors cursor-pointer"
                  >
                    {item.value}
                  </a>
                ) : (
                  <span className="text-sm text-neutral-700">{item.value}</span>
                )}
              </div>
            ))}
          </div>

          <div className="mt-16 p-8 bg-neutral-50 rounded-sm">
            <h2 className="font-heading text-2xl text-neutral-900 font-medium mb-4">Mentions légales</h2>
            <p className="text-sm text-neutral-500 leading-relaxed">
              Ce site est édité par Patrik Haspica, entrepreneur individuel. Conformément aux articles 6-III et 19 de la Loi n° 2004-575 du 21 juin 2004 pour la Confiance dans l'Économie Numérique (LCEN), ces informations sont mises à disposition du public.
            </p>
            <p className="text-sm text-neutral-500 leading-relaxed mt-3">
              Pour toute réclamation ou litige, la loi française est applicable et les tribunaux français sont compétents.
            </p>
          </div>

          <p className="text-xs text-neutral-400 mt-8">
            Dernière mise à jour : mars 2026
          </p>
        </div>
      </main>

      <Footer />
    </div>
  );
}
